var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavCustomDashboards = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.063 9.531a1 1 0 0 1 1 1v5.5a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1v-5.5a1 1 0 0 1 1-1zm8.437 2.813a1 1 0 0 1 1 1v2.687a1 1 0 0 1-1 1h-4.562a1 1 0 0 1-1-1v-2.687a1 1 0 0 1 1-1zm0-9.375a1 1 0 0 1 1 1v5.5a1 1 0 0 1-1 1h-4.562a1 1 0 0 1-1-1v-5.5a1 1 0 0 1 1-1zm-8.437 0a1 1 0 0 1 1 1v2.687a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1V3.97a1 1 0 0 1 1-1z"
})));
SvgNavCustomDashboards.displayName = "SvgNavCustomDashboards";
export { SvgNavCustomDashboards as ReactComponent };
export default SvgNavCustomDashboards;